import axios from 'axios';

const api = axios.create({
    baseURL: 'https://server.chery.com.ly/api',
    // baseURL: 'https://chery.wh-vps2.com/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

export default api;
